import { isFunction } from './isFunction';
import { isTrueOrZero } from './isTrueOrZero';

export interface PageScrollToProps {
	top?: number;
	left?: number;
}

export const pageScrollTo = ({ top, left }: PageScrollToProps) => {
	const element = document.body.parentElement;

	if (
		element &&
		isFunction(element.scrollTo) &&
		(isTrueOrZero(top) || isTrueOrZero(left))
	) {
		element.scrollTo({
			behavior: 'smooth',
			top: isTrueOrZero(top) ? top : 0,
			left: isTrueOrZero(left) ? left : 0,
		});
	}
};
